/* eslint-disable prettier/prettier */
import React from 'react'
import { Container } from '../styles/SobreOCursoLayout'

const SobreOCurso = () => (
  <Container>
    <div style={{marginBottom: '20px'}}>
      <span>Sobre o curso</span>
      <h2>TÉCNICO EM GUIA DE TURISMO NACIONAL/REGIONAL :</h2>
      <p>
      O aluno formado estará apto para atuar em sua Unidade da Federação de Registro 
      nas operações de planejamento, execução e avaliação de viagens, interpretando 
      e traduzindo o patrimônio material e imaterial para os visitantes, bem como 
      prestando suporte a eles, durante sua estada.
      </p>
      <p style={{marginTop: '10px'}}>
      Valorizar as características culturais históricas e ambientais da localidade atuando 
      como fomentador do desenvolvimento sustentável do turismo e da hospitalidade.
      </p>
      <p style={{marginTop: '10px'}}>
      Ao final do curso, o aluno desenvolverá habilidades técnicas para ser o responsável 
      pela recepção, condução, orientação e assistência de pessoas ou grupos durante 
      traslados, passeios, visitas e viagens em âmbito Local, Regional e Nacional .
      </p>
      <p style={{marginTop: '10px'}}>
      Para os que pretendam o cadastramento na categoria de Guia de Turismo Excursão 
      Internacional é necessário a apresentação do Exame de Proficiência, ou do Atestado 
      de Fluência em pelo menos uma língua estrangeira, que são fornecidos por Instituição
       de Ensino reconhecida pela autoridade competente ou a execução do Exame de 
       Proficiência no próprio CPET entrar em contato pelo e-mail eadmetodologia@gmail.com.
      </p>
      <h2>Carga Horaria Curricular do Curso Técnico em Guia de Turismo Nacional</h2>
      <ul>
        <li>↪ 1180 horas</li>
      </ul>
      <h2>Legalização do Curso Técnico em Guia de Turismo Nacional</h2>
      <ul>
        <li><a href="https://drive.google.com/file/d/1DMAFVIZ1K-4B62ZI7KdXsHJxIr5vGTIZ/view?usp=sharing" target="_blank" rel="noopener noreferrer">↪ Portaria nº 1274/2018 – SEEC/GS</a></li>
      </ul>
      <h2>Certificações Obtidas no Curso Técnico em Guia de Turismo Nacional</h2>
      <ul>
        <li>26 Certificados referentes a cada Curso Isolado Livre</li>
        <ol>
          <li>cada curso referencia um Componente Curricular</li>
        </ol>
        <li>03 Cursos de Formação Profissional :</li>
        <ol>
          <li>Auxiliar de Escritório Agência de Turismo – CBO – 4110-05</li>
          <li>Auxiliar de Organização de Eventos – CBO – 3548-20</li>
          <li>Auxiliar de Condutor de Turismo – CBO 5115-05</li>
        </ol>
        <li>02 Qualificações Profissionais Técnica de Nível Médio: (Saídas Intermediárias)</li>
        <ol>
          <li>Operador de Turismo – CBO – 3548-10</li>
          <li>Assistente de Guia Regional de Turismo – CBO – 3548-10</li>
        </ol>
      </ul>
      <h2>TÉCNICO DE NÍVEL MÉDIO EM GUIA DE TURISMO NACIONAL</h2>
      <ul>
        <ol>
          <li>tem sua atuação concentrada no acompanhamento e assistência a 
            grupos de turistas, durante todo o percurso de excursões em nível
            nacional ou realizada na América do Sul, adotando, em nome da agência
             de turismo responsável pelo roteiro, todas as atribuições de natureza 
             técnica e administrativa necessárias à fiel execução do programa
          </li>
        </ol>
      </ul>
      <h2>TÉCNICO DE NÍVEL MÉDIO EM GUIA DE TURISMO REGIONAL </h2>
      <ul style={{marginBottom: '20px'}}>
        <ol>
          <li>tem sua atividade voltada para recepcionar o traslado, acompanhar e
             prestação de informações e assistência a turistas, em itinerários ou
              roteiros locais ou intermunicipais de uma determinada unidade da 
              federação para visita a seus atrativos turísticos.
            Região / Estado da Federação definida de acordo com o Trabalho de Conclusão 
            de Curso Desenvolvido
          </li>
        </ol>
      </ul>
      <a href="https://www.cpet.com.br/course/curso-tecnico-em-guia-de-turismo-internacional-modalidade-a-distancia-2/" target="_blank" rel="noopener noreferrer">Para INFORMAÇÕES sobre a Habilitação Técnica de Nível Médio em :
                TÉCNICO DE NÍVEL MÉDIO EM GUIA DE TURISMO INTERNACIONAL clique aqui </a>

      <h2>Registro Profissional em Técnico em Guia de Turismo Nacional</h2>
      <ul>
        <ol>
          <li>↪ CADASTUR</li>
          <li>↪ Ministério do Turismo</li>
        </ol>
      </ul>  
      <h2>Atualizado em 08/01/2021</h2>
    </div>
  </Container>
)

export default SobreOCurso